// extracted by mini-css-extract-plugin
export var large = "styles-module--large--P+hxD";
export var normal = "styles-module--normal--GkTjs";
export var small = "styles-module--small---50LF";